{"languageLabel":"English","menu":{"home":"Home","products":"Products","contact":"Contact"}}